<app-modal-container [title]="title"
                     [buttonValidation]="searchReplaceInProgress"
                     (action)="searchReplace()">
  <app-search-replace-message (formArrayChanged)="setArrayValue($event)"></app-search-replace-message>
</app-modal-container>
